import React from 'react'
import { Document, Page } from 'react-pdf'

const DocumentPDF = ({ url }) => {
  const file = React.useMemo(() => ({ url, withCredentials: true }), [url])
  return (
    <Document file={file}>
      <Page pageNumber={1} renderTextLayer={false} />
    </Document>
  )
}

export default DocumentPDF
